import React from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  open: boolean;
  title?: string;
  onClose: () => void;
  children: React.ReactNode;
  width?: number;
  showClose?: boolean;
}
export function Modal({
  open,
  title,
  onClose,
  children,
  width = 390,
  showClose = true
}: ModalProps) {
  if (!open) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" role="dialog" aria-modal="true" data-id="element-330" data-mp="37wkmdj6edu9p">
      <button type="button" aria-label="Close dialog" onClick={onClose} className="absolute inset-0 bg-ink-900/40" data-id="element-331" data-mp="9cm0yyxh86cb" />
      <div className="relative max-h-[90vh] w-full overflow-y-auto rounded-lg bg-white shadow-pop" style={{
      maxWidth: width
    }} data-id="element-332" data-mp="4cg7rebk6bs4">
        {(title || showClose) && <div className="flex items-center justify-between gap-3 px-6 pb-4 pt-5" data-id="element-333" data-mp="3qnlfvror0xlv">
            {title && <h2 className="text-[17px] font-bold text-ink-900" data-id="element-334" data-mp="2k3c57ntutmfd">{title}</h2>}
            {showClose && <button type="button" onClick={onClose} aria-label="Close dialog" className="ml-auto rounded p-1 text-ink-500 hover:bg-ink-100" data-id="element-335" data-mp="2f8gdypwfz33b">
                <XIcon className="h-4 w-4" data-id="element-336" data-mp="285rx6znjoowa" />
              </button>}
          </div>}
        {children}
      </div>
    </div>;
}